{
    "name": "addin-web",
    "version": "1.4.24",
    "scripts": {
        "ng": "ng",
        "start": "npm run build:functions:dev && ng serve",
        "build:functions:dev": "cross-env APP_CONFIG=development webpack --config custom-functions/webpack.config.js --mode=development",
        "build:functions:stage": "cross-env APP_CONFIG=stage NODE_ENV=production webpack --config custom-functions/webpack.config.js --mode=production --node-env=production",
        "build:functions:prod": "cross-env APP_CONFIG=production NODE_ENV=production webpack --config custom-functions/webpack.config.js --mode=production --node-env=production",
        "build:prod": "npm run build:functions:prod && ng build --configuration=production && npm run write-version && npm run write-web-config",
        "build:dev": "npm run build:functions:dev && ng build --configuration=development && npm run write-version && npm run write-web-config",
        "build:stage": "npm run build:functions:stage && ng build --configuration=stage && npm run write-version && npm run write-web-config",
        "watch": "ng build --watch --configuration=production",
        "test": "ng test",
        "assemble-manifest": "node ./assemble-manifests.js",
        "generate-certificate": "npx office-addin-dev-certs install",
        "write-version": "node ./scripts/write-version.js",
        "write-web-config": "node ./scripts/write-web-config.js",
        "lint": "ng lint",
        "lint:fix": "ng lint --fix"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^17.0.0",
        "@angular/cdk": "^17.0.1",
        "@angular/cdk-experimental": "^17.0.1",
        "@angular/common": "^17.0.0",
        "@angular/compiler": "^17.0.0",
        "@angular/core": "^17.0.0",
        "@angular/forms": "^17.0.0",
        "@angular/material": "^17.0.1",
        "@angular/platform-browser": "^17.0.0",
        "@angular/platform-browser-dynamic": "^17.0.0",
        "@angular/router": "^17.0.0",
        "@azure/msal-browser": "3.30.0",
        "@messageformat/core": "^3.3.0",
        "@ng-select/ng-select": "^12.0.7",
        "@ngx-translate/core": "^15.0.0",
        "@tiptap/core": "^2.27.2",
        "@tiptap/extension-bubble-menu": "^2.27.2",
        "@tiptap/extension-floating-menu": "^2.27.2",
        "@tiptap/extension-link": "^2.27.2",
        "@tiptap/extension-placeholder": "^2.27.2",
        "@tiptap/extension-underline": "^2.27.2",
        "@tiptap/pm": "^2.27.2",
        "@tiptap/starter-kit": "^2.27.2",
        "@tiptap/suggestion": "2.27.2",
        "buffer": "^6.0.3",
        "marked": "^9.0.0",
        "ngx-indexed-db": "^16.0.0",
        "ngx-markdown": "^17.2.1",
        "ngx-tiptap": "^10.1.0",
        "ngx-translate-messageformat-compiler": "^6.5.0",
        "prismjs": "^1.28.0",
        "rxjs": "~7.8.0",
        "tiptap-markdown": "^0.8.10",
        "tslib": "^2.3.0",
        "uuid": "^9.0.1",
        "zone.js": "~0.14.2"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^17.0.1",
        "@angular-eslint/builder": "17.3.0",
        "@angular-eslint/eslint-plugin": "17.3.0",
        "@angular-eslint/eslint-plugin-template": "17.3.0",
        "@angular-eslint/schematics": "17.3.0",
        "@angular-eslint/template-parser": "17.3.0",
        "@angular/cli": "^17.0.1",
        "@angular/compiler-cli": "^17.0.0",
        "@types/custom-functions-runtime": "^1.6.8",
        "@types/jasmine": "~5.1.0",
        "@types/node": "^18.18.2",
        "@types/office-js": "^1.0.360",
        "@types/uuid": "^9.0.7",
        "@typescript-eslint/eslint-plugin": "7.2.0",
        "@typescript-eslint/parser": "7.2.0",
        "autoprefixer": "^10.4.16",
        "clean-webpack-plugin": "^4.0.0",
        "cross-env": "^7.0.3",
        "custom-functions-metadata-plugin": "^1.5.7",
        "dotenv-webpack": "^8.1.0",
        "eslint": "^8.57.0",
        "jasmine-core": "~5.1.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "postcss": "^8.4.31",
        "tailwindcss": "^3.3.5",
        "ts-loader": "^9.5.1",
        "typescript": "~5.2.2",
        "webpack": "^5.91.0",
        "webpack-cli": "^5.1.4"
    },
    "engines": {
        "node": ">=18.18.0",
        "yarn": ">=1.22.19",
        "npm": ">=9.8.1"
    }
}